import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { AccordionModule } from 'primeng/accordion';
import { TagModule } from 'primeng/tag';
import { constants} from '../../../../../shared/constants/constants'
import { HeadingComponent } from '../../../../../shared/components/heading/heading.component';
import { EducationService} from '../../../../../shared/services/education.service';
import { Education, Educations } from '../education.interface';
import { Router, RouterModule } from '@angular/router';
import { ConfirmationDialogService } from '../../../../../shared/services/confirmation-dialog.service';
import {ReviewerService} from '../../../../../shared/services/reviewer.service'
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DocumentService } from '../../../../../shared/services/document-service';
import { UserService } from '../../../../../shared/services/user.service';
import { ShareProfileDataComponent } from '../share-profile-data/share-profile-data.component';
import { Reviewer, Tenant } from '../../../../../store/reviewer/reviewer.interface';
import { ToastService } from '../../../../../shared/services/toast.service';
import { StorageService } from '../../../../../shared/services/storage.service';
import { HelperService } from '../../../../../shared/services/helper.service';
import { PipesModule } from '../../../../../shared/pipes/pipes.module';
import { CommonBaseClass } from '../../../../../shared/classes/common-base-class';
import { lastValueFrom } from 'rxjs';
@Component({
  selector: 'app-listing',
  standalone: true,
  imports: [CommonModule, ButtonModule,RouterModule, FloatLabelModule, CalendarModule, InputTextModule, DropdownModule, HeadingComponent, MultiSelectModule, AccordionModule, TagModule, PipesModule],
  templateUrl: './listing.component.html',
  styleUrl: './listing.component.scss'
})
export class ListingComponent extends CommonBaseClass implements OnInit {
  @Input() from: string = '';
  @Output() showCreateEducationForm: EventEmitter<any> = new EventEmitter();
  @Output() back: EventEmitter<any> = new EventEmitter();
  @Output() next: EventEmitter<any> = new EventEmitter();
  headingButton = {
    url: '/reviewer/profile/education/create',
    label: 'Add a Degree',
    colorClass: 'button-bg-pink'
  }
  educations:Educations = [];
  secureBackgroundStatus = constants.secureBackgroundStatus;
  educationDataLength = -1;
  reviewerInfo!: Reviewer;
  ref: DynamicDialogRef | undefined;
  selectedTenant: Tenant | undefined;
  resume: any = [];
  breadcrumbTitleOptions = [
    { label: 'Profile' }, 
    { label: 'Education' }
  ];
  isSkipButtonEnabled: boolean = false;
  
  constructor(
    private educationService: EducationService,
    private confirmationDialogService: ConfirmationDialogService,
    private reviewerService:ReviewerService,
    private dialogService: DialogService,
    private toast: ToastService,
    private userService: UserService,
    private documentService: DocumentService,
    private storageService: StorageService,
    private router: Router,
    helperService: HelperService
  ) {
    super(helperService);
  }

  editMode(event: any) {
    event.stopPropagation();
  }

  ngOnInit() {
    this.getEducations();
    this.getReviewerInfo();
    this.selectedTenant = this.storageService.getTenant();
    const tenants = this.reviewerService.getReviewerTenants();
    if(this.from === 'onboarding' && tenants.length > 0){
      const tenantWithPreviousEducation = tenants.find((tenant) => tenant.reviewerStatus === constants.userVerificationStatus.pendingAdminVerification || tenant.reviewerStatus === constants.userVerificationStatus.verified);
      if (tenantWithPreviousEducation) {
        this.getReviewerResumesAndCertificates(tenantWithPreviousEducation);        
      }
    }
  }

  getReviewerResumesAndCertificates(tenantWithPreviousEducation: Tenant){
    this.documentService.getFirmReviewerDocuments({firmId: tenantWithPreviousEducation!.firm._id, reviewerId: this.userService.getUserId()}).subscribe((docs) => {
      this.resume = docs.filter((doc: any) => doc.documentType === 'CERTIFICATION' || doc.documentType === 'RESUME');
      this.showShareProfileTenantPopup(tenantWithPreviousEducation);
    });
  }

  showShareProfileTenantPopup(tenantWithPreviousEducation: Tenant){
    if(this.resume.length){
      let data = {
        tenantId: tenantWithPreviousEducation?.firm._id,
        documents: this.resume,
      };
      this.ref = this.dialogService.open(ShareProfileDataComponent, {
        data: data,
        header: 'Share Profile Across Tenants',
        width: '30vw',
        contentStyle: { overflow: 'hidden' },
        breakpoints: {
          '960px': '75vw',
          '640px': '90vw'
        },
      });
      this.ref.onClose.subscribe((data: any) => {
        console.log(data);
        if (data) {   
          this.toast.showSuccess('Resume/Certificates Added Successfully');
        }
      });
    }
  }

  getEducations(){
    this.educationService.getEducations().subscribe((response:Educations)=>{
      this.educations = response;
      this.educationDataLength = response.length;
    })
  }

  status(data:Education): string{
    if(data.secureBackgroundResult === this.secureBackgroundStatus.meetsRequirement){
      return 'Verified';
    }else if(data.secureBackgroundStatus=== this.secureBackgroundStatus.pending || data.secureBackgroundResult=== this.secureBackgroundStatus.needsFurtherReview){
      return 'Verification in progress';
    }else if(data.secureBackgroundResult === this.secureBackgroundStatus.doesntMeetsRequirement){
      return ' Not verified';
    }else{
      return '';
    }
  }

  navigateToEditScreen(education: any): void{
    if(this.from === 'onboarding'){
      this.showCreateEducationForm.emit(education._id);
    } else {
      this.router.navigate([`/reviewer/profile/education/edit/${education._id}`]);
    }
  }

  showCreateSchool(){
    this.showCreateEducationForm.emit();
  }

  submit(type:any){
    if (type === 'back') {
      this.back.emit();
    } else {
      this.reviewerService.fetchReviewerAndUpdate();
      this.next.emit();
    }
  }

  onDelete($event: Event, education: Education) {
    $event.stopPropagation();
    this.confirmationDialogService.confirm({
      target: $event.target as EventTarget,
      message:`Are you sure you want to delete ${education.school.name} ?`,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'none',
      rejectIcon: 'none',
      rejectButtonStyleClass: 'p-button-text',
      accept: () => {
        this.educationService.deleteEducation(education._id).subscribe({
          next: (res) => {
            this.ngOnInit();
          },
        });
      },
    });
  }

  onBack(): void {
    this.navigateToMainProfile();
  }

  async getReviewerInfo(): Promise<void> {
    this.reviewerInfo = await lastValueFrom(
      this.reviewerService.fetchReviewer()
    );
    this.isSkipButtonVisible();
  }

  isSkipButtonVisible() {
    this.isSkipButtonEnabled = this.helperService.isSkipButtonVisible(this.reviewerInfo, this.from || '');
  }

  navigateToDashboard(): void {
    this.helperService.navigateToDashboard(this.reviewerInfo);
  }
}
